import Axios from 'axios';


export const getConfigLayout = () => Axios.get('configLayout', {
  transformRequest: (data, headers) => {
    delete headers['Authorization'];
  }
});
